export default function FormContainer({children}) {
    return <form className="w-full">{children}</form>;
}
